import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';

import { baseStyles, buttonStyles } from '@/styles';

import '@/components/personalisation/fg-personalisation';
import '../fg-configuration-print-option-summary';

import { PrintOptionMixin } from '../print-option-mixin';

@customElement('fg-configuration-print-option')
@localized()
export class FgConfigurationPrintOption extends PrintOptionMixin(LitElement) {
  render() {
    if (!this.printOption) {
      return null;
    }

    const {
      colorCount,
      fullColor,
      hasColorChoice,
      image,
      maxDimensions,
      personalization,
      printMethod,
      printPosition,
    } = this.printOption;

    const { type, logo } = personalization || {};
    const personalisationTypes = this.getPersonalisation(logo, personalization);
    const { personalizable } = this.configurationContext;

    return html`
      <div class="print-option">
        ${image
          ? html`
              <img
                src=${image}
                alt=${printPosition.name}
                width="64"
                height="64"
              />
            `
          : nothing}

        <div>
          <strong>${printPosition.name}</strong>

          <div class="print-option-details">
            <p>
              ${printMethod
                ? html`
                    ${printMethod.printTechnique.name}
                  `
                : nothing}
              ${printMethod && colorCount
                ? html`
                    -
                  `
                : nothing}
              ${colorCount
                ? t('content.configuration.colorCount', {
                    count: colorCount,
                  })
                : nothing}
            </p>

            ${fullColor
              ? html`
                  <p>${t('labels.fullColor')}</p>
                `
              : nothing}
            ${maxDimensions.description
              ? html`
                  <p>${maxDimensions.description}</p>
                `
              : nothing}
            ${personalization && type
              ? html`
                  <p class="print-option-personalisation-details">
                    <strong>${personalisationTypes[type].title}:</strong>
                    <span>
                      ${personalisationTypes[type]?.logo
                        ? html`
                            ${personalisationTypes[type]?.logo}
                          `
                        : nothing}
                      ${personalisationTypes[type].description
                        ? html`
                            <br />
                            <span
                              style="
                        ${personalisationTypes[type]?.fontFamily
                                ? `font-family:${personalisationTypes[type]?.fontFamily}`
                                : nothing}"
                            >
                              ${personalisationTypes[type].description}
                            </span>
                          `
                        : nothing}
                    </span>
                  </p>
                `
              : html`
                  <p>
                    ${t('labels.logoDelivery')}
                    ${personalizable
                      ? html`
                          -
                          <button
                            class="button-link"
                            @click=${this.openPersonalisationDialog}
                          >
                            ${t('actions.deliverNow')}
                          </button>
                        `
                      : nothing}
                  </p>
                `}
          </div>
        </div>

        <fg-personalisation
          ${ref(this.fgPersonalisationDialogRef)}
          .printOption=${this.printOption}
          .hasColorChoice=${hasColorChoice}
          @personalisation-completed=${this.savePersonalisationData}
        >
          <fg-configuration-print-option-summary
            slot="print-option-summary"
            .option=${this.printOption}
          ></fg-configuration-print-option-summary>
        </fg-personalisation>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      strong {
        font-size: 1rem;
      }

      .print-option {
        align-items: center;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
        display: flex;
        gap: 8px;
        padding: 15px 8px;
      }

      .print-option img {
        aspect-ratio: 64 / 64;
        object-fit: contain;
      }

      .print-option-details {
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-top: 5px;
      }

      .print-option-personalisation-details {
        margin-top: 15px;
      }

      .print-option-personalisation-details strong {
        display: block;
      }
    `,
  ];
}
